<template>
	<div class="supporters mh-700">
		<v-layout row wrap>
			<v-flex xs12>
				<ViewHeader
					src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fblue-sky-desert-h800.jpg?alt=media&token=3e87d3e1-749c-486a-b159-5b7f19335738"
					title="Supporters"
				/>
			</v-flex>
		</v-layout>
		<v-layout row wrap align-center justify-center class="pt-4">
			<v-flex xs12 v-for="logo in majorLogos" :key="logo.index">
				<div class="supporter-wrapper">
					<img class="supporter-logo" v-bind:src="logo.path" />
				</div>
			</v-flex>
		</v-layout>
		<v-layout row wrap class="pb-4">
			<v-flex xs12 v-for="logo in minorLogos" :key="logo.index">
				<div class="supporter-wrapper">
					<img class="supporter-logo" v-bind:src="logo.path" />
				</div>
			</v-flex>
		</v-layout>
		<v-layout row wrap class="pb-4">
			<v-flex xs12 v-for="logo in minorLogos2" :key="logo.index">
				<div class="supporter-wrapper">
					<img class="supporter-logo" v-bind:src="logo.path" />
				</div>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<div class="disclaimer">
					<p>Funding for this conference was made possible in part by R13AG067693 from National Institute on Aging. 
					The views expressed in written conference materials or publications and by speakers and moderators do not 
					necessarily reflect the official policies of the Department of Health and Human Services; nor does mention 
					of trade names, commercial practices, or organizations imply endorsement by the U.S. Government.</p>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
import ViewHeader from '@/components/ViewHeader.vue';
export default {
	name: 'supporters',
	components: {
		ViewHeader
	},
	data: function() {
		return {
			subtitle: 'Supporters',
			majorLogos: [
				{
					name: 'National Institute on Aging',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fnih-nia-logo.png?alt=media&token=a9d45851-1226-4897-8137-1369664e7ec0',
					linkUrl: ''
				},
				{
					name: 'International Society for Neurochemistry',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fisn-logo.png?alt=media&token=b0c5793c-b8af-41e9-8314-eab111dc613b',
					linkUrl: ''
				},
				{
					name:
						'UNM Health Sciences Center for Brain Recovery & Repair',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FUNM_logo.png?alt=media&token=e073de33-a633-4075-a7ae-d98a5b71bfb5',
					linkUrl: ''
				}
			],
			minorLogos: [
				{
					name: 'ISBFM',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FISCBFM_logo.png?alt=media&token=d6adf82d-c840-4cb8-a499-f0c973b37bb1',
					linkUrl: ''
				},
				{
					name: 'KU Hoglund Biomedical Imaging Center',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FHBIC-logo.png?alt=media&token=754c346d-583c-429e-b6fa-e738af208347',
					linkUrl: ''
				},
				{
					name: 'KU Neurology',
					path: 
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FKU_Neurology_logo.jpg?alt=media&token=44761b70-1cb0-424b-b62d-98503a272d69',
					linkUrl: ''
				}
			],
			minorLogos2: [
				{
					name: 'Journal of Neurochemistry',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FJNC_logo.png?alt=media&token=7bd89d63-b8c0-417f-8423-291bd4433f62',
					linkUrl: ''
				},
				{
					name: 'Millipore Sigma',
					path:
						'https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2FMilliporeSigma_logo.png?alt=media&token=1e08e36e-c859-44da-906d-5173e5d5640a',
					linkUrl: ''
				}
			]
		};
	}
};
</script>
<style scoped>
.supporter-wrapper {
	padding: 16px;
	text-align: center;
}
.disclaimer {
	padding: 32px;
	text-align: center;
}
</style>
